import {Outlet} from "react-router-dom";

export default function ClassDetailsTab() {
    return (<Outlet/>);
}
